import { render } from "./VisitDetails.vue?vue&type=template&id=bb6acb62&scoped=true"
import script from "./VisitDetails.vue?vue&type=script&lang=js"
export * from "./VisitDetails.vue?vue&type=script&lang=js"

import "./VisitDetails.vue?vue&type=style&index=0&id=bb6acb62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb6acb62"]])

export default __exports__